import { defineComponent as o, openBlock as t, createBlock as r, unref as l, mergeProps as p, withCtx as d, createElementVNode as e } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const s = /* @__PURE__ */ o({
  name: "IconSmartphoneCamera",
  __name: "IconSmartphoneCamera",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(c) {
    const n = c;
    return (u, a) => (t(), r(l(m), p(n, { "view-box": "0 0 24 24" }), {
      default: d(() => [...a[0] || (a[0] = [
        e("path", { d: "M21 2.25H9.367c-1.092 0-1.958 0-2.655.057-.714.058-1.317.18-1.868.46a4.75 4.75 0 0 0-2.076 2.077c-.281.55-.403 1.154-.461 1.868C2.25 7.409 2.25 8.275 2.25 9.367V21a.75.75 0 0 0 1.5 0V9.4c0-1.132 0-1.937.052-2.566.05-.62.147-1.005.302-1.31a3.25 3.25 0 0 1 1.42-1.42c.305-.155.69-.251 1.31-.302C7.464 3.751 8.268 3.75 9.4 3.75H21a.75.75 0 0 0 0-1.5" }, null, -1),
        e("path", { d: "M10.5 8a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m3.5 8.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M10.5 15a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3" }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M14.25 10.5a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0m2.25-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M18.629 4.75H8.37a13 13 0 0 0-1.017.023C7.057 4.797 6.762 4.85 6.479 4.995A2.25 2.25 0 0 0 5.495 5.98C5.351 6.262 5.297 6.557 5.273 6.854 5.25 7.134 5.25 7.476 5.25 7.87v10.26c0 .395 0 .736.023 1.017a2.3 2.3 0 0 0 .222.875 2.25 2.25 0 0 0 .984.984 2.3 2.3 0 0 0 .875.222A14 14 0 0 0 8.37 21.25h10.26c.395 0 .736 0 1.017-.023a2.3 2.3 0 0 0 .875-.222 2.25 2.25 0 0 0 .984-.983 2.3 2.3 0 0 0 .222-.876c.023-.28.023-.622.023-1.017V7.87c0-.395 0-.736-.023-1.017a2.3 2.3 0 0 0-.222-.875 2.25 2.25 0 0 0-.983-.984 2.3 2.3 0 0 0-.876-.222c-.28-.023-.622-.023-1.017-.023M7.159 6.332c.038-.02.113-.047.317-.064A13 13 0 0 1 8.4 6.25h10.2c.432 0 .712 0 .924.018.204.017.28.045.316.064a.75.75 0 0 1 .328.328c.02.037.047.112.064.316A13 13 0 0 1 20.25 7.9v10.2c0 .432 0 .712-.018.924-.017.204-.045.28-.064.316a.75.75 0 0 1-.328.328c-.037.02-.112.047-.316.064A13 13 0 0 1 18.6 19.75H8.4c-.432 0-.712 0-.924-.018-.204-.017-.28-.045-.316-.064a.75.75 0 0 1-.328-.328c-.02-.037-.047-.112-.064-.316A13 13 0 0 1 6.75 18.1V7.9c0-.432 0-.712.018-.924.017-.204.045-.28.064-.316A.75.75 0 0 1 7.16 6.332",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
